import { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";

/** Fetch a protected file via backend and return a blob URL. Cleans up on unmount. */
export function useAuthedImage(storagePath) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!storagePath) { setSrc(null); return; }
    let url;
    let cancel = false;
    (async () => {
      try {
        const r = await api.get(`/files/${storagePath}`, { responseType: "blob" });
        if (cancel) return;
        url = URL.createObjectURL(r.data);
        setSrc(url);
      } catch {}
    })();
    return () => { cancel = true; if (url) URL.revokeObjectURL(url); };
  }, [storagePath]);
  return src;
}

export async function uploadImage(file) {
  // Client-side sanity check — multimodal models reject very small images
  await new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (img.width < 64 || img.height < 64) {
        resolve(Promise.reject(new Error("Image too small (min 64×64)")));
      } else resolve();
    };
    img.onerror = () => resolve();
    img.src = URL.createObjectURL(file);
  });
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, size }
}

export function fileUrl(storagePath) {
  const t = localStorage.getItem("cling_token") || "";
  return `${API_BASE}/files/${storagePath}?token=${encodeURIComponent(t)}`;
}
